import styled from 'styled-components';
import { Avatar } from '@mui/material';

export const NewestVoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  .newest-voice-header {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    align-self: flex-start;
  }
`;

export const SmallAvatarStyled = styled(Avatar)`
  width: 24px;
  height: 24px;
`;
